<div class="container-sucesso">
  <h1>Autenticação bem-sucedida!</h1>
  <p>Você foi autenticado com sucesso no sistema.</p>
  <p>Esta é a página padrão de redirecionamento dos aplicativos do CEI após o login.</p>
  <a href="#" (click)="voltar($event)">
    Voltar para a página anterior
  </a>
</div>